'use client';

import { Bars2Icon, XMarkIcon } from '@heroicons/react/24/solid';
import { useTranslations } from 'next-intl';
import { CommandPaletteTriggerButton } from './command-palette';
import { LanguageSwitcherNav } from './language-switcher-nav';

interface IMobileNavMenuProps {
  open: boolean;
  onToggle: () => void;
}

export function MobileNavMenu({ open, onToggle }: IMobileNavMenuProps): React.JSX.Element {
  const t = useTranslations('nav');
  return (
    <div className="lg:hidden flex items-center">
      <CommandPaletteTriggerButton variant="icon" />
      <LanguageSwitcherNav />
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls="mobile-nav-panel"
        aria-label={t('ariaOpenMenu')}
        className="flex size-12 items-center justify-center self-center rounded-lg text-foreground data-hover:bg-accent"
      >
        {open ? <XMarkIcon className="size-6" /> : <Bars2Icon className="size-6" />}
      </button>
    </div>
  );
}
